export default "__VITE_ASSET__CCgxOJkV__"